"use client"

import {
  Button,
  Code,
  Container,
  Heading,
  HStack,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react"

import ErrorIllustration from "@/components/Illustrations/ErrorIllustration"

export default function Error({
  error,
  reset = () => window.location.reload(),
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <Container maxW="8xl" mb={["5", "0"]}>
      <VStack
        alignItems="center"
        as="section"
        display="flex"
        justifyContent="center"
        minH="70vh"
        p={4}
      >
        <VStack bg={"bg.paper"} gap={6} p={8} rounded={"2xl"}>
          <VStack
            alignItems="center"
            color="red.600"
            justifyContent={"flex-start"}
            mt={12}
            width={"full"}
          >
            <ErrorIllustration maxWidth="360px" />
            <Heading fontFamily="mono" mt={4} size="2xl">
              Something went wrong!
            </Heading>
          </VStack>
          <Stack align="left" direction="column" gap="2" mt={5} width="full">
            <Text
              _dark={{ color: "gray.400" }}
              color="gray.600"
              fontFamily="mono"
            >
              Error Info:
            </Text>
            <Code
              colorPalette={"red"}
              size="md"
              textAlign={"left"}
              variant="subtle"
            >
              {error.message || "An error occurred while loading the page."}
            </Code>
            <Text
              _dark={{ color: "gray.400" }}
              color="gray.600"
              fontFamily="mono"
              mt={5}
            >
              Stack Trace:
            </Text>
            <Code
              colorPalette={"gray"}
              size="sm"
              textAlign={"left"}
              variant="outline"
            >
              {error.stack}
            </Code>
          </Stack>
          <HStack justifyContent={"center"} mb={5} mt={5}>
            <Button colorPalette="primary" onClick={reset}>
              Try to reload the page
            </Button>
          </HStack>
        </VStack>
      </VStack>
    </Container>
  )
}
